import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { OverlayService } from './overlay.service';

@Injectable({ providedIn: 'root' })
export class NotificationToasterService {

  constructor(
    private toastr: ToastrService,
    private overlay: OverlayService
  ) {}

  success(message: string, title?: string) {

    this.overlay.show();

    const toast = this.toastr.success(message, title);

    toast.onHidden.subscribe(() => {
      this.overlay.hide();
    });
  }

  error(message: string, title?: string) {

    this.overlay.show();

    const toast = this.toastr.error(message, title);

    toast.onHidden.subscribe(() => {
      this.overlay.hide();
    });
  }

  warning(message: string, title?: string) {

    this.overlay.show();

    const toast = this.toastr.warning(message, title);

    toast.onHidden.subscribe(() => {
      this.overlay.hide();
    });
  }

  clear(){
    this.toastr.clear();
    this.overlay.hide();
  }
}